import React from "react";

const testimonials = [
  {
    id: 1,
    name: "John Doe",
    role: "Investor",
    content:
      "CryptoInvest has transformed the way I approach cryptocurrency investments. Their platform is intuitive and their market insights are invaluable.",
    image:
      "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-4.0.3&auto=format&fit=crop&w=1170&q=80",
  },
  {
    id: 2,
    name: "Jane Smith",
    role: "Financial Advisor",
    content:
      "As a financial advisor, I recommend CryptoInvest to my clients. Their security measures and diverse portfolio options are unmatched in the industry.",
    image:
      "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-4.0.3&auto=format&fit=crop&w=1169&q=80",
  },
  {
    id: 3,
    name: "Michael Brown",
    role: "Crypto Enthusiast",
    content:
      "I love how easy it is to manage my investments on CryptoInvest. The customer support team is always ready to help.",
    image:
      "https://images.unsplash.com/photo-1595152772835-219674b2a8a6?ixlib=rb-4.0.3&auto=format&fit=crop&w=1169&q=80",
  },
  {
    id: 4,
    name: "Emily Clark",
    role: "Beginner Investor",
    content:
      "CryptoInvest helped me get started in cryptocurrency without feeling overwhelmed. Their educational resources are top-notch.",
    image:
      "https://images.unsplash.com/photo-1544005313-94ddf0286df2?ixlib=rb-4.0.3&auto=format&fit=crop&w=1169&q=80",
  },
];

const stats = [
  {
    id: 1,
    label: "Total Trading Pairs",
    value: "120+",
  },
  {
    id: 2,
    label: "Happy Clients",
    value: "50,000+",
  },
  {
    id: 3,
    label: "Investors",
    value: "10,000+",
  },
];

function TestimonialCard({ name, role, content, image }) {
  return (
    <div className="bg-white rounded-xl shadow-lg shadow-gray-700 p-6">
      <p className="text-gray-600 mb-4">{content}</p>
      <div className="flex items-center">
        <img
          src={image || "/placeholder.svg"}
          alt={name}
          className="w-12 h-12 rounded-full mr-4"
        />
        <div>
          <h4 className="font-semibold text-black">{name}</h4>
          <p className="text-gray-500 text-sm">{role}</p>
        </div>
      </div>
    </div>
  );
}

function StatCard({ label, value }) {
  return (
    <div className="bg-white rounded-xl shadow-md shadow-gray-700 p-6 text-center">
      <h3 className="text-4xl font-bold text-blue-600">{value}</h3>
      <p className="text-gray-500 mt-2">{label}</p>
    </div>
  );
}

function Testimonials() {
  return (
    <section className="py-16 bg-gray-800">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-bold text-center mb-12 text-white">What Our Clients Say</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {testimonials.map((testimonial) => (
            <TestimonialCard key={testimonial.id} {...testimonial} />
          ))}
        </div>
      </div>
      <div className="container mx-auto px-4 mt-16">
        <h2 className="text-3xl font-bold text-center mb-12 text-white">Our Achievements</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {stats.map((stat) => (
            <StatCard key={stat.id} {...stat} />
          ))}
        </div>
      </div>
    </section>
  );
}

export default Testimonials;